// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"grid_wrapper__28jDj"};